import httpService from "./httpService.js";

export const getAllTicketsService = () => {
  return httpService("/ticket_admin_panel/ticket_admin/", "get");
};

export const getTicketContextsService = (ticketCode) => {
  return httpService(`/ticket_admin_panel/ticket_admin/${ticketCode}/`, "get");
};

export const getTicketOrderContext = (ordercode) => {
  return httpService(
    `/ticket_admin_panel/ticket_admin/${ordercode}/order_ticket_messages/`,
    "get"
  );
};

export const getTicketOrder = (ordercode) => {
  return httpService(
    `/ticket_admin_panel/ticket_admin/${ordercode}/order_ticket/`,
    "get"
  );
};

export const getTicketServiceContext = (servicecode) => {
  return httpService(
    `/ticket_admin_panel/ticket_admin/${servicecode}/service_ticket_messages/`,
    "get"
  );
};

export const getTicketService = (servicecode) => {
  return httpService(
    `/ticket_admin_panel/ticket_admin/${servicecode}/service_ticket/`,
    "get"
  );
};

export const createNewTicketService = (data) => {
  return httpService("/ticket_admin_panel/ticket_admin/", "post", data);
};

export const editTicketUserRolesService = (ticketCode, data) => {
  return httpService(
    `/ticket_admin_panel/ticket_admin/${ticketCode}/`,
    "patch",
    data
  );
};

export const editTicketStatusService = (ticketCode, data) => {
  return httpService(
    `/ticket_admin_panel/update_ticket_admin/${ticketCode}/`,
    "patch",
    data
  );
};

export const updateTicket = (ticketCode, data) => {
  return httpService(
    `/ticket_admin_panel/ticket_admin/${ticketCode}/send_email_or_sms/`,
    "patch",
    data
  );
};

export const getTicket = (ticketCode) => {
  return httpService(
    `/ticket_admin_panel/ticket_admin/${ticketCode}/send_email_or_sms/`,
    "get"
  );
};

export const createNewMessageSerivce = (ticketCode, data) => {
  return httpService(
    `/ticket_admin_panel/create_message/${ticketCode}/`,
    "post",
    data,
    "multipart/form-data"
  );
};

export const getAllUserRolesService = () => {
  return httpService("/accounts/user_role/", "get");
};

export const getAllServicesCodesService = () => {
  return httpService("/ticket_admin_panel/services_codes/", "get");
};

export const getAllCustomersEmails = () => {
  return httpService("/ticket_admin_panel/customers_emails/", "get");
};
